<template>
  <div class="flow-state">
    <div class="box">
      <div class="title">
        <img src="@/assets/index/joinParty/dp-lc1-icon1.png" alt />
        当前流程状态
        <button @click="isSendMsg=true">我要回复</button>
        <!-- <span @click="goLeaveBoard">留言记录</span> -->
      </div>
      <div class="content">
        <div class="content-template" v-for="(data,index) in datas" :key="index">
          <!-- 18584860748 -->
          <div class="shows">
            <div class="left" v-if="data.usertype===1">
              <p>
                <span>管理员</span>
                {{data.newstime | timeMinute}}
              </p>
              <p v-text="data.newscontent"></p>
            </div>
            <div class="right" v-if="data.usertype!==1">
              <p>
                {{data.newstime | timeMinute}}
                <span>我的</span>
                <!-- <span>点击回复</span> -->
              </p>
              <p v-text="data.newscontent"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 回复消息 -->
    <div class="sendMsg" v-show="isSendMsg">
      <el-input placeholder="请输入内容" v-model="sendMsg" clearable></el-input>
      <el-button type="primary" @click="FsendMsg">发送消息</el-button>
      <i class="el-icon-circle-close" @click="isSendMsg=false"></i>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: [],
      imgOk: require("@/assets/index/joinParty/dp-lc1-icon4.png"),
      imgNo: require("@/assets/index/joinParty/dp-lc1-icon8.png"),
      imgWait: require("@/assets/index/joinParty/dp-lc1-icon5.1.png"),
      sendMsg: "",
      isSendMsg: false
    };
  },
  name: "flowState",
  props: {
    name: Number
  },
  methods: {
    judge(value) {
      if (value && value != "暂未到此流程") return true;
      else return false;
    },
    mytext(value) {
      let imgUrl;
      if (value.state != null) {
        if (value.state == "暂未到此流程") imgUrl = this.imgWait;
        else if (value.state.indexOf("审核未通过") > -1) imgUrl = this.imgNo;
        else imgUrl = this.imgOk;
        return imgUrl;
      }
      return this.imgWait;
    },
    goLeaveMessage() {
      this.$parent.shows = 1;
    },
    goLeaveBoard() {
      this.$parent.shows = 2;
    },
    getMsg() {
      // console.log(this.$parent.$children[2]);
      this.axios
        .get(
          `/api/Index/GetRecord?stateid=${this.name +
            1}&userid=${sessionStorage.getItem("id")}`
        )
        .then(e => {
          console.log("flowState", e.data);
          switch (e.data.code) {
            case 0:
              // console.log(e.data.msg[0].Objecttext1);
              e.data.msg.filter(item => {
                this.datas.push(item);
              });
              break;

            default:
              break;
          }
        });
    },
    FOpenMsg() {
      this.isSendMsg = true;
    },
    FsendMsg() {
      if (this.sendMsg != "") {
        this.axios
          .post("/api/Index/PostUsernews", {
            userid: sessionStorage.getItem("id"),
            stateid: this.name + 1,
            newsname: sessionStorage.getItem("name"),
            newscontent: this.sendMsg
            // newstime: new Date()
          })
          .then(e => {
            if (e.data.code == 0) {
              location.reload()
            } else {
              alert("发送失败");
            }
          });
      }
    }
  },
  mounted() {
    // console.log('flowState',this.name);
    this.getMsg();
  },
  filters: {
    timeMinute: function(value) {
      if (value !== null && value !== "" && value !== undefined) {
        return value.replace("T", " ");
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.flow-state {
  .sendMsg {
    i {
      color: #999999;
      font-size: 0.5rem;
      position: absolute;
      top: -0.5rem;
      right: 0;
    }
    display: flex;
    justify-content: space-between;
    width: 100%;
    position: fixed;
    bottom: 0;
  }

  .box {
    .content {
      .content-template {
        .shows {
          .left {
            p {
              &:first-child {
                span {
                  background: #f9ba4f;
                  color: #fff;
                  padding: 0.1rem 0.2rem;
                  border-radius: 0.08rem;
                  margin-right: 0.2rem;
                }
                padding: 0.1rem;
                color: #999999;
              }
              &:nth-child(2) {
                span {
                  margin-left: 0.5rem;
                  font-size: 0.2rem;
                }
              }
              padding: 0 0.2rem;
              line-height: 2;
            }

            &::before {
              content: "";
              position: absolute;
              right: -0.2rem;
              top: 0.05rem;
              width: 0;
              height: 0;
              border-top: 0.1rem solid transparent;
              border-left: 0.2rem solid #f9f9f9;
              border-bottom: 0.1rem solid transparent;
            }
            background: #f9f9f9;
            border-radius: 0.08rem;
            position: relative;
            text-align: right;
            max-width: 70%;
            margin-top: 0.3rem;
            text-align: left;
            margin-left: .2rem;

          }
          .right {
            p {
              &:first-child {
                span {
                  background: #1688e1;
                  color: #fff;
                  padding: 0.1rem 0.2rem;
                  border-radius: 0.08rem;
                  margin-left: 0.2rem;
                }
                padding: 0.1rem;
                color: #999999;
              }
              &:nth-child(2) {
                span {
                  margin-left: 0.5rem;
                  font-size: 0.2rem;
                }
              }
              padding: 0 0.2rem;
              line-height: 2;
            }

            &::before {
              content: "";
              position: absolute;
              left: -0.2rem;
              top: 0.05rem;
              width: 0;
              height: 0;
              border-top: 0.1rem solid transparent;
              border-right: 0.2rem solid #f9f9f9;
              border-bottom: 0.1rem solid transparent;
            }
            background: #f9f9f9;
            border-radius: 0.08rem;
            position: relative;
            text-align: right;
            max-width: 70%;
            margin-left: auto;
            margin-top: 0.3rem;
            margin-right: .2rem;
          }
          text-align: center;

          display: grid;
        }
      }
    }

    .title {
      span {
        text-decoration: underline;
        color: #1095fc;
        margin: 0 0.3rem;
      }
      button {
        padding: 0.1rem 0.2rem;
        border: none;
        background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
        border-radius: 0.08rem;
        font-size: 0.3rem;
        color: #fff;
        margin-left: auto;
        margin-right: 0.2rem;
      }
      img {
        width: 0.48rem;
        height: 0.48rem;
        border-radius: 50%;
        margin: 0.2rem;
      }
      display: flex;
      align-items: center;
      line-height: 3;
    }
    width: 94%;
    margin: 0 auto;
    background: #fff;
    border-radius: 0.08rem;
    font-size: 0.3rem;
    border-top: solid 0.2rem #f9f9f9;
    padding-bottom: 0.5rem;
  }
}
</style>
